'use strict';

require('../../style/index.less');

require('./index.less');

require('../../checkbox/style');

require('../../button/style');

require('../../input/style');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/transfer/style/index.js
// module id = 1002
// module chunks = 0